<template>
  <div class="container">
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="项目续约" name="first"
          ><Xmxy v-if="activeName == 'first'"></Xmxy
        ></el-tab-pane>
        <el-tab-pane label="一把手变更" name="second"
          ><Ybs v-if="activeName == 'second'"></Ybs
        ></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import {} from "@/api/course.js";
import Xmxy from "./xmxy_index.vue";
import Ybs from "./ybs_index.vue";
export default {
  name: "course",
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  components: {
    Xmxy,
    Ybs,
  },
  data() {
    return {
      activeName: "first",
    };
  },
  created() {
    sessionStorage.setItem("acitveNameZxlc", "first");
    this.$store.dispatch("common/fetchUserInfoAction");
    // if (localStorage.getItem("zxlcIndexTab") == 1) {
    //   this.activeName = "second";
    //   localStorage.removeItem("zxlcIndexTab");
    // }
  },
  mounted() {},
  methods: {
    handleClick(e) {
      sessionStorage.setItem("acitveNameZxlc", e.name);
    },
  },
};
</script>
<style lang='less' scoped>
.container {
  padding: 15px;
  height: 100%;
  box-sizing: border-box;
  min-width: 1100px;
}
::v-deep .el-tabs__nav-scroll {
  background-color: #fff;
}
</style>